/*******************************************************************************
FILTER ITEMS
Handles a click on a tab.
*******************************************************************************/

import checkForMatch from './check-for-match';
import manageEmptyState from './manage-empty-state';

export default function filterItems(filterSettings, tabSettings) {

    const $items = $(filterSettings.items);

    // If the match criteria is '*', then all rows should be shown and we can exit out
    if (tabSettings.dataToMatch === '*') {
        $items.removeClass('hide-filtertab');
        $('.filter-tab-empty').addClass('hide-filtertab');
        return;
    }

    // Check to see if there are any tables on the page
    const checkForTable = $('.webix_dtable').length > 0;

    // Check each item to see if it matches the filter tab criteria
    $items.each((index, item) => {
        const $item = $(item);

        // Check to see if the current item matches the filter
        const filterMatches = checkForMatch($item, filterSettings, tabSettings);

        // Filter the items so that only the matching ones are visible
        if (filterMatches) {
            $item.removeClass('hide-filtertab');

            // Check to see if the item contains a table.
            // If it does, fire off a custom event letting us know that the table may need to be refreshed
            if (checkForTable) {
                $item.find('.webix_dtable').each((index, tableItem) => {
                    const tableID = $(tableItem).attr('id');
                    $(document).trigger(`tableNeedsRefresh:${tableID}`);
                });
            }
        }
        else {
            $item.addClass('hide-filtertab');
        }
    });

    // Figure out if the empty state should be displayed or not
    manageEmptyState(filterSettings.items);
}
